/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

import React, { useState, useEffect } from "react";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import Icon from "@mui/material/Icon";
import styles from "./index.module.css";
import { useNotification } from "context/NotificationContext";

// import files images
import excel from "assets/images/file-icons/excel.png";
import image from "assets/images/file-icons/image.png";
import music from "assets/images/file-icons/music.png";
import pdf from "assets/images/file-icons/pdf.png";
import text from "assets/images/file-icons/text.png";
import word from "assets/images/file-icons/word.png";
import zip from "assets/images/file-icons/zip.png";

const apiUrl = process.env.REACT_APP_AUTH_API_URL;

const FileSingle = ({ userId, subfolder, documentType }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [existingFile, setExistingFile] = useState(null);
  const [path, setPath] = useState([subfolder]);
  const { showNotification } = useNotification();

  useEffect(() => {
    downloadFiles();
  }, [userId, path]);

  const downloadFiles = async () => {
    const currentPath = path.join("/");
    const response = await fetch(`${apiUrl}/file_list.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ user_id: userId, path: currentPath }),
    });
    const result = await response.json();
    setExistingFile(result.message.files[0]);
  };

  const deleteFile = async () => {
    const formData = new FormData();
    formData.append("user_id", userId);
    formData.append("path", `${path.join("/")}/${existingFile}`);

    await fetch(`${apiUrl}/file_delete.php`, {
      method: "POST",
      body: formData,
    });

    downloadFiles();
  };

  const downloadFile = (file) => {
    const fileUrl = `${apiUrl}/uploads/${userId}/${path}/${file}`;
    const anchor = document.createElement("a");
    anchor.href = fileUrl;
    anchor.download = file;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };

  const renderFile = (file) => (
    <button className={styles.folder} onDoubleClick={() => downloadFile(file)}>
      <img src={renderFileIcon(file.split(".").pop())} alt={file} />
      <div className={styles.folderName}>{file}</div>
    </button>
  );

  const renderFileIcon = (ext) => {
    switch (ext.toUpperCase()) {
      case "PDF":
        return pdf;
      case "DOC":
      case "DOCX":
        return word;
      case "MP3":
      case "WAV":
        return music;
      case "RAR":
      case "ZIP":
        return zip;
      case "CSV":
      case "XML":
      case "XLS":
      case "XLSX":
        return excel;
      case "EXE":
      case "TTF":
        return text;
      case "PNG":
      case "GIF":
      case "JPEG":
      case "JPG":
        return image;
      case "TXT":
        return text;
      default:
        return text;
    }
  };

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleFileUpload = async () => {
    if (!selectedFile) {
      showNotification({
        color: "error",
        icon: <Icon>error</Icon>,
        title: "Errore",
        dateTime: new Date().toLocaleString(),
        content: "Seleziona un file valido",
      });
      return;
    }
    if (existingFile) {
      await deleteFile();
    }

    const formData = new FormData();
    formData.append("path", path.join("/"));
    formData.append("user_id", userId);
    formData.append("file[]", selectedFile);
    try {
      const response = await fetch(`${apiUrl}/file_upload.php`, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      if (response.ok) {
        // Refresh the existing file info after upload
        showNotification({
          color: "success",
          icon: <Icon>success</Icon>,
          title: "Successo",
          dateTime: new Date().toLocaleString(),
          content: "caricamento del file riuscito",
        });
        setSelectedFile(null);
        downloadFiles();
      } else {
        alert("File upload failed: " + data.message);
      }
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  return (
    <MDBox display="flex" flexDirection={{ xs: "column" }} alignItems="center" gap={1}>
      <MDTypography variant="h6" className={styles.centeredItem}>
        {documentType}
      </MDTypography>
      {existingFile && (
        <MDBox mb={2}>
          <MDTypography variant="body1">{renderFile(existingFile)}</MDTypography>
        </MDBox>
      )}
      <MDInput type="file" onChange={handleFileChange} className={styles.centeredItem} />
      <MDButton color="primary" variant="contained" onClick={handleFileUpload}>
        <Icon style={{ marginRight: 10 }}>upload</Icon>
        Carica File
      </MDButton>
    </MDBox>
  );
};

export default FileSingle;
